/** UNCHANGED consume — account type on rows and on errors[].type */
export type AccountInventoryType = string;

/** Wire row from AIM. Sample fields are examples, not a closed enum. */
export interface AccountInventoryRow {
  id?: string | null;
  idMasked?: string | null;
  name?: string | null;
  institution?: string | null;
  type?: AccountInventoryType | null;
  status?: string | null;
  /** AIM may send `null` (e.g. declined / never-funded Kashable). */
  balance?: number | null;
  /** Open vs closed for Default (open only). Live AIM may send `isActive` instead. */
  isOpen?: boolean;
  isActive?: boolean;
}

/** UNCHANGED consume — per-type failure; omitted types are not in accounts[] */
export interface AccountInventoryError {
  type: AccountInventoryType | string;
  message: string;
}

/** NEW — payload only; pair with GenericResponseResult from ApiService */
export interface GetAccountsPayload {
  accounts: AccountInventoryRow[];
  errors?: AccountInventoryError[];
}

export interface GetAccountsResponse {
  payload: GetAccountsPayload;
}

export interface AccountsBanner {
  headline: string;
  body: string;
}

export type AccountsSortColumn = 'name' | 'institution' | 'type' | 'status' | 'balance';
export type AccountsSortDirection = 'asc' | 'desc';

export const ACCOUNTS_STATUS_OPEN = 'open';
export const ACCOUNTS_STATUS_ALL = 'all';
export const ACCOUNTS_TYPE_ALL = 'all';

export type AccountsGroupBy = 'none' | 'institution' | 'type' | 'status';
export type AccountsStatusFilter = typeof ACCOUNTS_STATUS_OPEN | typeof ACCOUNTS_STATUS_ALL | string;
export type AccountsTypeFilter = typeof ACCOUNTS_TYPE_ALL | string;
export type AccountsFilterKind = 'status' | 'type' | 'group_by';

export interface AccountsSelectOption {
  label: string;
  value: string;
}

export interface AccountsInventoryGroup {
  key: string;
  label: string;
  count: number;
  rows: AccountInventoryRow[];
}
